import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Sidebar as SemanticSidebar } from "semantic-ui-react";

import LoadingGate from "../../components/LoadingGate";
import { loadApp, isLoading, getLoadError } from "../../actions/load";

import Sidebar from "../../components/Sidebar";

// import AnalyticsView from "../pages/AnalyticsView";
import TransactionsView from "../pages/TransactionsView";
import BudgetView from "../pages/BudgetView";
// import FlowView from "../pages/FlowView";
import ReimbursementsView from "../pages/ReimbursementsView";
import SettingsView from "../pages/SettingsView";
import ProfileView from "../pages/ProfileView";

import "./AppView.css";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  hasCapability,
  VIEW_REIMBURSEMENTS,
  MODIFY_ORGANIZATION,
  VIEW_TRANSACTIONS
} from "../../util/capability";

const homePath = () => {
  if (hasCapability(VIEW_REIMBURSEMENTS)) return "/reimbursements";
  else if (hasCapability(VIEW_TRANSACTIONS)) return "/transactions";
  else if (hasCapability(MODIFY_ORGANIZATION)) return "/settings";
  else return "/profile";
};

const _HomeRedirect = props => (
  <div>
    {props.render && (
      <Route path="/" component={() => <Redirect to={homePath()} />} />
    )}
  </div>
);

const HomeRedirect = withRouter(
  connect(
    state => {
      return {
        render: state.load.status === "finished"
      };
    },
    null
  )(_HomeRedirect)
);

const AppView = props => (
  <div className="appview-wrapper">
    <div className="sidebar-container">
      <Sidebar />
    </div>
    <SemanticSidebar.Pusher className="sidebar-pusher">
      <div style={{ padding: "2em" }}>
        <Switch>
          {hasCapability(VIEW_REIMBURSEMENTS) && (
            <Route path="/reimbursements" component={ReimbursementsView} />
          )}
          {hasCapability(MODIFY_ORGANIZATION) && (
            <Route path="/settings" component={SettingsView} />
          )}
          {hasCapability(VIEW_TRANSACTIONS) && (
            <Route path="/transactions" component={TransactionsView} />
          )}
          <Route path="/budget" component={BudgetView} />
          {
            // <Route path="/flow" component={FlowView} />
            // <Route path="/analytics" component={AnalyticsView} />
          }
          <Route path="/profile" component={ProfileView} />
          <HomeRedirect />
        </Switch>
      </div>
    </SemanticSidebar.Pusher>
  </div>
);

export default () => (
  <LoadingGate
    loadedComponent={AppView}
    loadAction={loadApp}
    isLoading={isLoading}
    getError={getLoadError}
  />
);



// WEBPACK FOOTER //
// ./frontend/src/views/AppView/index.js